const COMMON_PASSWORDS = [
  'password', '12345678', 'qwerty', 'abc123', 'password1', 
  'letmein', 'welcome', 'monkey', '1234567890', 'password123'
]

export const validators = {
  email: (value: string) => {
    if (!value) return false
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(value) && value.length <= 254
  },
  
  password: (value: string) => {
    const errors: Record<string, string> = {}
    
    if (value.length < 8) {
      errors.length = 'Must be at least 8 characters'
    }
    
    if (value.length > 128) {
      errors.length = 'Must be less than 128 characters'
    }
    
    if (!/[A-Z]/.test(value)) {
      errors.uppercase = 'Must contain uppercase letter'
    }
    
    if (!/[a-z]/.test(value)) {
      errors.lowercase = 'Must contain lowercase letter'
    }
    
    if (!/\d/.test(value)) {
      errors.number = 'Must contain number'
    }
    
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value)) {
      errors.special = 'Must contain special character'
    }
    
    if (COMMON_PASSWORDS.includes(value.toLowerCase())) {
      errors.common = 'Password is too common'
    }
    
    if (/(.)\1{2,}/.test(value)) {
      errors.repeated = 'Contains too many repeated characters'
    }
    
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    }
  },
  
  phone: (value: string) => {
    if (!value) return false
    const cleaned = value.replace(/\D/g, '')
    return cleaned.length >= 10 && cleaned.length <= 15
  },
  
  url: (value: string) => {
    if (!value) return false
    try {
      const url = new URL(value)
      return ['http:', 'https:'].includes(url.protocol)
    } catch {
      return false
    }
  },
  
  required: (value: any) => {
    if (value === null || value === undefined) return false
    if (typeof value === 'string') return value.trim() !== ''
    if (Array.isArray(value)) return value.length > 0
    return true
  }
}

export const sanitize = {
  input: (value: string) => {
    if (!value || typeof value !== 'string') return ''
    return value
      .trim()
      .replace(/[<>]/g, '')
      .replace(/javascript:/gi, '')
      .replace(/on\w+\s*=/gi, '')
      .slice(0, 1000)
  },
  
  email: (value: string) => {
    if (!value || typeof value !== 'string') return ''
    return value
      .toLowerCase()
      .trim()
      .replace(/[^\w@.-]/g, '')
      .slice(0, 254)
  },
  
  html: (value: string) => {
    if (!value || typeof value !== 'string') return ''
    const map: Record<string, string> = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;',
      '/': '&#x2F;',
      '`': '&#x60;',
      '=': '&#x3D;'
    }
    return value.replace(/[&<>"'/`=]/g, s => map[s] || s)
  }
}

export const validateForm = <T extends Record<string, any>>(
  data: T,
  rules: Record<keyof T, { validator: (value: any) => boolean; message: string }>
): { isValid: boolean; errors: Partial<Record<keyof T, string>> } => {
  const errors: Partial<Record<keyof T, string>> = {}
  
  Object.keys(rules).forEach((key) => {
    const field = key as keyof T
    const rule = rules[field]
    if (!rule.validator(data[field])) {
      errors[field] = rule.message
    }
  })
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  }
}